import { Injectable } from '@angular/core';
import { RoutePathBuilder } from '@ngspot/route-path-builder';

@Injectable()
export class RoutesForReplenishments extends RoutePathBuilder {
    queue() {
        return this.url('');
    }

    replenish() {
        return this.url('perform');
    }
}
